<template>
  <WizardStep name="summary">
    <PersonalSummary
      :gender="formContext.getOptionSetValue('genders', 'personal.gender')"
      :firstname="formContext.getValue('personal.firstname')"
      :lastname="formContext.getValue('personal.lastname')"
      :phone="formContext.getValue('personal.phone')"
      :availability="
        formContext
          .getOptionSetValue('contactTimes', 'info.availableAt', [])
          .concat(formContext.getValue('info.notes', []))
          .join(', ')
      "
      :email="formContext.getValue('personal.email')"
      :date-of-birth="formContext.getValue('dateOfBirth.date')"
      :street="formContext.getValue('address.street')"
      :postal-code="formContext.getValue('address.postalCode')"
      :city="formContext.getValue('address.city')"
      :country="formContext.getOptionSetValue('countries', 'address.country')"
    />
    <slot />
    <TextareaField
      label="Wenn Du uns abschließend noch etwas mitteilen möchtest, trage dies gerne hier ein:"
      placeholder="Anmerkungen, z.B. Wunscharbeitszeiten oder Erreichbarkeit"
      name="notes"
      validation="optional"
    />
    <Panel slot="footer">
      <ConsentField />
    </Panel>
  </WizardStep>
</template>

<script>
import formContextAware from '../mixin/formContextAware';

export default {
  mixins: [formContextAware],
};
</script>
